import { takeLatest, takeEvery, call, put } from "redux-saga/effects";
import {
  GET_IMAGES_REQUEST,
  GET_TAGS_REQUEST,
  GET_PEXELS_IMAGES_REQUEST,
  getImagesSuccess,
  getImagesFailure,
  getPexelsImagesSuccess,
  getPexelsImagesFailure,
  getTagsSuccess,
  getTagsFailure,
  GET_PRESIGNED_URLS_REQUEST,
  GET_PRESIGNED_PUT_URLS_REQUEST,
  getPresignedUrlsSuccess,
} from "../actions/mediaActions";
import {
  getImagesApi,
  getPexelsImagesApi,
  fetchPresignedUrlsFromApi,
  fetchPresignedPutUrlsFromApi,
  getTagsApi,
} from "../apis/mediaApi";

// Worker saga: will be fired on GET_IMAGES_REQUEST actions
function* getImagesSaga(action) {
  console.log(
    `PMM - SF - mediaSaga - getImagesSaga - action is: ${JSON.stringify(
      action
    )}`
  );
  try {
    const response = yield call(getImagesApi, action.payload);
    console.log(
      `PMM - SF - mediaSaga - getImagesSaga - response is: ${JSON.stringify(
        response
      )}`
    );
    if (response?.data?.getSelectedImages) {
      console.log(
        `PMM - SF - mediaSaga - getImagesSaga - response?.data?.getSelectedImages?.libraryCards is: ${JSON.stringify(
          response?.data?.getSelectedImages?.libraryCards
        )}`
      );
      yield put(getImagesSuccess(response.data.getSelectedImages.libraryCards));
    } else {
      yield put(getImagesFailure("No images found"));
    }
  } catch (e) {
    console.error(`PMM - SF - mediaSaga.js - Error: ${e.message}`);
    // Dispatch failure action on error
    yield put(getImagesFailure(e.message));
  }
}

function* getPexelsImagesSaga(action) {
  console.log(
    `PMM - SF - mediaSaga - getPexelsImagesSaga - action is: ${JSON.stringify(
      action
    )}`
  );
  try {
    const response = yield call(getPexelsImagesApi, action.payload);
    console.log(
      `PMM - SF - mediaSaga - response is: ${JSON.stringify(response)}`
    );
    if (response) {
      // console.log(
      //   `PMM - SF - mediaSaga - response is: ${JSON.stringify(response)}`
      // );
      yield put(getPexelsImagesSuccess(response));
    } else {
      yield put(getPexelsImagesFailure("No Pexels images found"));
    }
  } catch (e) {
    console.error(`PMM - SF - mediaSaga.js - Error: ${e.message}`);
    // Dispatch failure action on error
    yield put(getPexelsImagesFailure(e.message));
  }
}

// Saga to handle the get presigned URLs action
function* getPresignedUrlsSaga(action) {
  try {
    const payload = {
      operationType: "GET_THUMBNAIL_URLS",
      entityType: "IMAGE",
      filenames: action.payload,
    };
    // console.log(
    //   `PMM - SF - saga - getPresignedUrlsSaga - fetching URLs for files: ${JSON.stringify(
    //     payload
    //   )}`
    // );
    const presignedUrls = yield call(fetchPresignedUrlsFromApi, action.payload);
    // console.log(
    //   `PMM - SF - saga - getPresignedUrlsSaga - received presigned presignedUrls: ${JSON.stringify(
    //     presignedUrls
    //   )}`
    // );
    yield put(getPresignedUrlsSuccess(presignedUrls)); // Dispatch success action
  } catch (error) {
    console.error("Error fetching pre-signed URLs:", error); // Handle error
  }
}

function* getPresignedPutUrlsSaga(action) {
  try {
    const payload = {
      operationType: "GET_PRESIGNED_URLS",
      entityType: "IMAGE",
      filenames: action.payload,
    };
    // console.log(
    //   `PMM - SF - saga - getPresignedPutUrlsSaga - fetching URLs for files: ${JSON.stringify(
    //     payload
    //   )}`
    // );
    const presignedUrls = yield call(
      fetchPresignedPutUrlsFromApi,
      action.payload
    );
    // console.log(
    //   `PMM - SF - saga - getPresignedUrlsSaga - received presigned presignedUrls: ${JSON.stringify(
    //     presignedUrls
    //   )}`
    // );
    yield put(getPresignedUrlsSuccess(presignedUrls)); // Dispatch success action
  } catch (error) {
    console.error("Error fetching pre-signed URLs:", error); // Handle error
  }
}

// Worker saga: will be fired on GET_TAGS_REQUEST actions
function* getTagsSaga(action) {
  try {
    // console.log(
    //   `PMM - SF - mediaSaga.js - getTagsSaga action is: ${JSON.stringify(
    //     action
    //   )}`
    // );
    // console.log(`PMM - SF - mediaSaga.js - getTagsSaga invokeded`);
    const response = yield call(getTagsApi, action.payload);
    // console.log(
    //   `PMM - SF - mediaSaga.js - getTagsSaga response is: ${JSON.stringify(
    //     response?.data
    //   )}`
    // );

    if (response?.data?.getMediaIndexTags?.tags) {
      // console.log(`PMM - SF - saga - writing success action for tags`);
      // Dispatch success action with the tags
      yield put(getTagsSuccess(response.data.getMediaIndexTags.tags));
    } else {
      // Dispatch failure action if no tags returned
      yield put(getTagsFailure("No tags found"));
    }
  } catch (e) {
    console.error(
      `PMM - SF - mediaSaga.js - Error fetching tags: ${e.message}`
    );
    // Dispatch failure action on error
    yield put(getTagsFailure(e.message));
  }
}

// Watcher saga: spawns a new getImagesSaga task on each GET_IMAGES_REQUEST
// and getTagsSaga task on each GET_TAGS_REQUEST
export default function* mediaSaga() {
  // console.log(`PMM - SF - mediaSaga initiated`);
  yield takeLatest(GET_IMAGES_REQUEST, getImagesSaga);
  yield takeLatest(GET_PEXELS_IMAGES_REQUEST, getPexelsImagesSaga);
  yield takeLatest(GET_PRESIGNED_URLS_REQUEST, getPresignedUrlsSaga);
  yield takeLatest(GET_PRESIGNED_PUT_URLS_REQUEST, getPresignedPutUrlsSaga);
  yield takeLatest(GET_TAGS_REQUEST, getTagsSaga);
}

// Named exports if needed for API usage directly elsewhere
export { getImagesApi, getPresignedUrlsSaga, getTagsApi };
